import { render, staticRenderFns } from "./Pos-table-booking.vue?vue&type=template&id=fc4cdf50&"
import script from "./Pos-table-booking.vue?vue&type=script&lang=js&"
export * from "./Pos-table-booking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports